import { notifyWoInvitedVendors } from '../utils/woInviteNotify';
import client from './inventory-request';
import { withStoreCreateBody, withStoreUpdateBody } from '../hooks/useStoreScope';

export const getWorkOrders = (p) => client.get('/inventory/work-orders/', p);

export const getWorkOrder = (id) => client.get(`/inventory/work-orders/${id}/`);

export const createWorkOrder = (body) => client.post('/inventory/work-orders/', withStoreCreateBody(body));

export const updateWorkOrder = (id, body) => client.patch(`/inventory/work-orders/${id}/`, withStoreUpdateBody(body));

export const publishWorkOrder = (id) => client.post(`/inventory/work-orders/${id}/publish/`, {});

export const issueWorkOrder = (id) => client.post(`/inventory/work-orders/${id}/issue/`, {});

export const cancelWorkOrder = (id, body = {}) => client.post(`/inventory/work-orders/${id}/cancel/`, withStoreUpdateBody(body));

export const startWorkOrder = (id) => client.post(`/inventory/work-orders/${id}/start/`, {});

export const holdWorkOrder = (id, body = {}) => client.post(`/inventory/work-orders/${id}/hold/`, withStoreUpdateBody(body));

export const resumeWorkOrder = (id) => client.post(`/inventory/work-orders/${id}/resume/`, {});

export const completeWorkOrder = (id, body = {}) => client.post(`/inventory/work-orders/${id}/complete/`, withStoreUpdateBody(body));

export const closeWorkOrder = (id) => client.post(`/inventory/work-orders/${id}/close/`, {});

export const awardWorkOrder = (id, body) => client.post(`/inventory/work-orders/${id}/award/`, withStoreUpdateBody(body));

export const getWorkOrderPortalLink = (id) => client.get(`/inventory/work-orders/${id}/portal-link/`);

export const emailWorkOrderVendors = (id, vendorIds) =>
  client.post(`/inventory/work-orders/${id}/vendor-email-invite/`, { vendor_ids: vendorIds });

export const getWorkOrderQuotes = (id) => client.get(`/inventory/work-orders/${id}/quotes/`);

export const submitWorkOrderQuote = (id, body) => client.post(`/inventory/work-orders/${id}/quotes/`, body);

export const respondToWorkOrder = (id, body) => client.post(`/inventory/work-orders/${id}/vendor-response/`, body);

export async function createAndPublishWorkOrder(formPayload, { publish = false, issue = false } = {}) {
  const created = await createWorkOrder(formPayload);
  const id = created.id || created.work_order_id;
  if (publish) {
    const published = await publishWorkOrder(id);
    const notify = await notifyWoInvitedVendors(id, {
      wo: { ...formPayload, ...published },
      vendorIds: formPayload.invited_vendor_ids,
    }).catch((err) => ({ sent: [], failed: [{ reason: err.message }] }));
    return { ...created, ...published, id, notify };
  }
  if (issue) {
    const issued = await issueWorkOrder(id);
    return { ...created, ...issued, id };
  }
  return { ...created, id };
}

export async function updateAndPublishWorkOrder(id, formPayload, { publish = false, issue = false } = {}) {
  await updateWorkOrder(id, formPayload);
  if (publish) {
    const published = await publishWorkOrder(id);
    const notify = await notifyWoInvitedVendors(id, {
      wo: { ...formPayload, ...published },
      vendorIds: formPayload.invited_vendor_ids,
    }).catch((err) => ({ sent: [], failed: [{ reason: err.message }] }));
    return { ...published, id, notify };
  }
  if (issue) {
    const issued = await issueWorkOrder(id);
    return { ...issued, id };
  }
  return getWorkOrder(id);
}
